import AppComponent from '../../mixins/app-component'

import AppIcon from '../app-icon'

export default
{
    name: 'app-footer',

    mixins: [
        AppComponent
    ],

    components: {
        AppIcon
    },

    methods: {
        _getURLFromComponent(component) {
            let url = '/'

            Object.keys(this.CONFIG.pages).forEach(key => {
                const page = this.CONFIG.pages[key]

                if (page.name === component) {
                    url = page.path
                }
            })

            return url
        }
    }
}



// WEBPACK FOOTER //
// ./src/scripts/components/app-footer/script.js